export class DashboardConstants {
    public static readonly FilterTimer: number = 2000;
}
